module.exports = __webpack_public_path__ + "static/media/ahnuld.00293883.jpeg";